<template>
  <div
    class="mx-auto mt-40"
    style="width: 960px; min-height: calc(100vh - 32px)"
  >
    <div class="grid-2-auto mt-16">
      <div>
        <div class="flex">
          <img
            src="../assets/images/twotone-play_arrow-24px.png"
            class="icon-pages"
            alt="Setup Wizard"
          />
          <span class="page-title">{{ $t("page.setup_wizard") }}</span>
        </div>
        <div class="page-des">{{ $t("page.setup_wizard_description") }}</div>
      </div>
      <div class="button-title">
        <el-button
          @click.prevent="helpModalStatus = true"
          class="btn-green"
          type="primary"
          >{{ $t("global.ark_for_help") }}</el-button
        >
      </div>
    </div>

    <div class="border-container pt-18 pb-32 flex-mid mt-30 mb-16">
      <div class="node center">
        <div
          class="node-cycle flex-mid"
          :class="{ 'node-process': steps === 1, 'node-done': steps > 1 }"
        >
          1
        </div>
        <div class="relative node">
          <div class="step-title">{{ $t("setupWizard.stepOne.title") }}</div>
        </div>
      </div>
      <div class="line-nonde" :class="{ 'line-done': steps > 1 }"></div>
      <div class="node center">
        <div
          class="node-cycle flex-mid"
          :class="{ 'node-process': steps === 2, 'node-done': steps > 2 }"
        >
          2
        </div>
        <div class="relative node">
          <div class="step-title">{{ $t("setupWizard.stepTwo.title") }}</div>
        </div>
      </div>
      <div class="line-nonde" :class="{ 'line-done': steps > 2 }"></div>
      <div class="node center">
        <div
          class="node-cycle flex-mid"
          :class="{ 'node-process': steps === 3, 'node-done': steps > 3 }"
        >
          3
        </div>
        <div class="relative node">
          <div class="step-title">{{ $t("setupWizard.stepThree.title") }}</div>
        </div>
      </div>
      <div class="line-nonde" :class="{ 'line-done': steps > 3 }"></div>
      <div class="node center">
        <div
          class="node-cycle flex-mid"
          :class="{ 'node-process': steps === 4 }"
        >
          4
        </div>
        <div class="relative node">
          <div class="step-title">{{ $t("setupWizard.stepFour.title") }}</div>
        </div>
      </div>
    </div>

    <div
      v-if="steps == 1"
      class="border-container p-40"
      style="padding-top: 42px"
    >
      <div class="fw-700 fs-20 mb-15 flex">
        <div>{{ $t("setupWizard.stepOne.hi") }} {{ "Firstname" }}</div>
        <div class="ml-20">{{ $t("setupWizard.stepOne.header") }}</div>
      </div>
      <div class="fs-16">
        <div class="mb-26">{{ $t("setupWizard.stepOne.contentOne") }}</div>
        <div>{{ $t("setupWizard.stepOne.contentTwo") }}</div>
      </div>
      <div style="transition: 0.3s">
        <div class="fs-16 fw-700 mt-24 mb-12">
          {{ $t("setupWizard.stepOne.What_are_your") }}
        </div>
        <div class="core-value-container">
          <el-tag
            class="core-value-tag"
            v-for="(item, index) in coreValueData"
            :key="item + index + '_tags'"
          >
            {{ item.label }}
            <i
              @click="removeTag(index)"
              style="margin-left: 2px; margin-right: 2px; font-size: 18px"
              class="el-icon-close"
            ></i>
          </el-tag>
        </div>

        <div class="mt-24 flex-center" style="flex-wrap: wrap; gap: 12px 0">
          <span
            @click="showPeerFeedbackInput"
            v-if="!savePeerFeedbackInput"
            class="core-value-add-btn flex-center cursor-pointer"
          >
            <span class="mr-12 fs-16"
              ><i class="el-icon-plus" style="font-weight: 700"></i
            ></span>
            <span class="">Add another value</span>
          </span>
          <input
            class="core-value-add-btn input"
            v-if="savePeerFeedbackInput"
            v-model="savePeerFeedbackValue"
            ref="savePeerFeedbackInput"
            @keyup.enter="handleInputPeerFeedbackConfirm"
            @blur="handleInputPeerFeedbackConfirm"
          />
        </div>
        <div style="height: 153px"></div>
        <div class="relative">
          <img
            src="../assets/images/registor/illus_wizard_1.png"
            alt="working day"
            class="step-one-image"
          />
        </div>
        <div
          @click.prevent="steps = 2"
          class="big-buttom flex-mid"
          style="width: 172px"
        >
          <div class="fs-18 fw-700">{{ $t("global.next") }}</div>
          <img
            src="../assets/images/registor/ic_right_arrow.png"
            class="icon-buttom-primary"
          />
        </div>
      </div>
    </div>

    <div
      v-else-if="steps == 2"
      class="border-container p-40"
      style="padding-top: 42px"
    >
      <div class="fw-700 fs-20 mb-15">
        {{ $t("setupWizard.stepTwo.header") }}
      </div>
      <div class="fs-16">
        <div class="mb-20">{{ $t("setupWizard.stepTwo.contentOne") }}</div>
      </div>
      <div class="grid-2-50 gap-24">
        <div>
          <div class="input-titile mb-6">Team Name</div>
          <el-input
            class="form-48"
            placeholder="ACME Inc"
            v-model="createTeamForm.teamName"
            :class="{ 'validate-input': validateTeamForm.teamName }"
          ></el-input>
          <div v-if="validateTeamForm.teamName" class="validate-worming">
            <div class="text">Please input team name</div>
          </div>
          <div class="grid-2-auto gap-16 mt-12">
            <div>
              <div class="input-titile mb-6">Manager’s Name</div>
              <el-input
                class="form-48"
                placeholder="Name"
                v-model="createTeamForm.managerName"
                :class="{ 'validate-input': validateTeamForm.managerName }"
              ></el-input>
              <div v-if="validateTeamForm.managerName" class="validate-worming">
                <div class="text">Please input manager’s name</div>
              </div>
            </div>
            <div>
              <div class="input-titile mb-6">Email</div>
              <el-input
                class="form-48"
                placeholder="name@example.com"
                v-model="createTeamForm.emailManager"
                :class="{
                  'validate-input': validateTeamForm.emailManager,
                  'validate-input': validateTeamForm.detectEmailManager,
                }"
              ></el-input>
              <div
                v-if="validateTeamForm.emailManager"
                class="validate-worming"
              >
                <div class="text">Please input manager’s email</div>
              </div>
              <div
                v-else-if="validateTeamForm.detectEmailManager"
                class="validate-worming"
              >
                <div class="text">Please input correct email</div>
              </div>
            </div>
          </div>
          <div class="grid-2-50 mt-24" style="margin-bottom: -6px">
            <div class="input-titile">Member Name</div>
            <div class="input-titile ml-8">Email</div>
          </div>
          <div
            v-for="(user, index) in createTeamForm.members"
            :key="index + '-addMember'"
            class="grid-2-auto gap-16 mt-12"
          >
            <div>
              <el-input
                class="form-48"
                placeholder="Name"
                v-model="user.name"
                :class="{
                  'validate-input': validateTeamForm.members[index].name,
                }"
              ></el-input>
              <div
                v-if="validateTeamForm.members[index].name"
                class="validate-worming"
              >
                <div class="text">Please input manager’s name</div>
              </div>
            </div>
            <div>
              <el-input
                class="form-48"
                placeholder="name@example.com"
                v-model="user.email"
                :class="{
                  'validate-input': validateTeamForm.members[index].detectEmail,
                }"
              ></el-input>
              <div
                v-if="validateTeamForm.members[index].email"
                class="validate-worming"
              >
                <div class="text">Please input members email</div>
              </div>
              <div
                v-else-if="validateTeamForm.members[index].detectEmail"
                class="validate-worming"
              >
                <div class="text">Please input correct email</div>
              </div>
            </div>
          </div>
        </div>
        <div class="relative">
          <img
            src="../assets/images/registor/illus_wizard_2.png"
            alt="working day"
            class="step-two-image"
          />
          <div class="text-add-more">
            <span @click="addSlotMember" class="add-more">
              {{
                20 > this.validateTeamForm.members.length
                  ? `Add More (${
                      20 - this.validateTeamForm.members.length
                    } spots available)`
                  : "Maxinum"
              }}
            </span>
          </div>
        </div>
      </div>
      <div
        @click.prevent="validateData"
        class="big-buttom flex-mid"
        style="width: 172px; margin-top: 86px"
      >
        <div class="fs-18 fw-700">{{ $t("global.next") }}</div>
        <img
          src="../assets/images/registor/ic_right_arrow.png"
          class="icon-buttom-primary"
        />
      </div>
    </div>

    <div
      v-else-if="steps == 3"
      class="border-container p-40"
      style="padding-top: 42px"
    >
      <div class="fw-700 fs-20 mb-15">
        {{ $t("setupWizard.stepThree.title") }}
      </div>
      <div class="fs-16">
        <div class="mb-30">{{ $t("setupWizard.stepThree.contentOne") }}</div>
      </div>
      <div class="gird-2-reward">
        <div>
          <div
            @click.prevent="rewardSelected = 'companyPerks'"
            class="card-reward mb-24 flex"
            :class="{ 'card-checked': rewardSelected == 'companyPerks' }"
          >
            <div
              class="checkbox-reward"
              :class="{ checked: rewardSelected == 'companyPerks' }"
            >
              <div
                class="checkbox"
                :class="{ 'reward-checked': rewardSelected == 'companyPerks' }"
              ></div>
            </div>
            <div>
              <div class="fs-18 fw-700">
                {{ $t("setupWizard.stepThree.SelectOneTitle") }}
              </div>
              <div class="fs-14 margin-content-reward">
                {{ $t("setupWizard.stepThree.SelectOneContentOne") }}
              </div>
              <div class="fs-14 mt-16 margin-content-reward">
                {{ $t("setupWizard.stepThree.SelectOneContentTwo") }}
              </div>
            </div>
          </div>
          <!-- @click.prevent="rewardSelected = 'selectReward'" -->
          <div
            class="card-reward disable-card flex"
            :class="{ 'card-checked': rewardSelected == 'selectReward' }"
          >
            <div
              class="checkbox-reward"
              :class="{ checked: rewardSelected == 'selectReward' }"
            >
              <div
                class="checkbox"
                :class="{ 'reward-checked': rewardSelected == 'selectReward' }"
              ></div>
            </div>
            <div>
              <div class="fs-18 fw-700">
                {{ $t("setupWizard.stepThree.SelectTwoTitle") }}
              </div>
              <div class="fs-14 margin-content-reward">
                {{ $t("setupWizard.stepThree.SelectTwoContentOne") }}
              </div>
              <div class="fs-14 mt-16 margin-content-reward">
                {{ $t("setupWizard.stepThree.SelectTwoContentTwo") }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex-mid">
          <img
            src="../assets/images/registor/illus_wizard_3.png"
            alt="Reward Box"
            class="ml-20"
          />
        </div>
      </div>
      <div
        @click.prevent="steps = 4"
        class="big-buttom flex-mid"
        style="width: 172px; margin-top: 42px"
      >
        <div class="fs-18 fw-700">{{ $t("global.next") }}</div>
        <img
          src="../assets/images/registor/ic_right_arrow.png"
          class="icon-buttom-primary"
        />
      </div>
    </div>

    <div
      v-else-if="steps == 4"
      class="border-container p-40"
      style="padding-top: 42px"
    >
      <div class="fw-700 fs-20 mb-15">
        {{ $t("setupWizard.stepFour.title") }}
      </div>
      <div class="fs-16">
        <div class="mb-20">{{ $t("setupWizard.stepFour.contentOne") }}</div>
      </div>
      <div class="fs-16 grid-2-50 mb-40">
        <div>
          <div class="opa-05 fw-700">
            {{ $t("setupWizard.stepFour.quickSettings") }}
          </div>
          <el-form id="stepFourCard" class="mt-24 mb-40">
            <el-form-item style="margin-bottom: 16px" prop="date1">
              <span slot="label" class="inputLabelStyle">{{
                $t("setupWizard.stepFour.dailyPulse")
              }}</span>
              <el-time-picker
                :picker-options="{ selectableRange: '05:00:00 - 15:00:00' }"
                format="h:mm A"
                value-format="h:mm A"
                class="inputReportStyle"
                type="fixed-time"
                v-model="gen_question"
              ></el-time-picker>
              <span
                style="
                  pointer-events: none;
                  font-size: 18px;
                  color: #b5b5b5;
                  position: absolute;
                  left: 157px;
                  top: 6px;
                "
                >Mon - Fri</span
              >
            </el-form-item>
          </el-form>
          <div class="opa-05 fw-700 mb-12">
            {{ $t("setupWizard.stepFour.whatHappensNext") }}
          </div>
          <div>{{ $t("setupWizard.stepFour.contentOneWhatHappensNext") }}</div>
          <div class="fw-700 mt-24">
            {{ $t("setupWizard.stepFour.contentTwoWhatHappensNext") }}
          </div>
        </div>
        <div class="flex-mid">
          <img
            src="../assets/images/registor/illus_wizard_4.png"
            alt="Reward Box"
            class="ml-20"
          />
        </div>
      </div>
      <div
        @click.prevent="inviteMember"
        class="big-buttom flex-mid"
        style="width: 240px"
      >
        <div class="fs-18 fw-700 mr-24">Confirm & Invite</div>
        <img
          src="../assets/images/registor/ic_right_arrow.png"
          class="icon-buttom-primary"
        />
      </div>
      <div class="relative">
        <div
          v-if="sendModalStatus"
          @click="
            $router.push({
              path: 'members/members',
              query: { welcome: 'true' },
            })
          "
          class="modal-sended center fs-16"
        >
          <div class="flex-mid" style="height: 100vh">
            <div
              class="flex-mid send-email-card cursor-pointer"
              style="height: 480px"
            >
              <div>
                <div class="fs-28 mb-24 mt-16 fw-900">Invitations Sent!</div>
                <div>
                  The invitation emails have been sent to your team’s inbox.
                </div>
                <div class="mb-30">
                  Download links for iOS and Android included.
                </div>
                <img
                  src="../assets/images/registor/illus_tutorial_0.png"
                  alt="mail sended"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="helpModalStatus"
      width="720px"
      class="remove-header"
    >
      <div class="modal-body">
        <div class="fs-24 fw-900 mb-8">We are here to help!</div>
        <div class="fs-16 mb-40">
          We would like to make your setup process as easy as possible. Please
          connect with us over Facebook Messenger on LINE. We’ll do our best to
          respond to you as soon as possible!
        </div>
        <div class="fs-20 fw-700 mb-24">
          Connect with us on Facebook Messenger
        </div>
        <div
          class="fb-messengermessageus"
          messenger_app_id="616709712337272"
          page_id="2346452788918588"
          color="blue"
          size="standard"
        ></div>
        <a
          href="http://m.me/happilydotai"
          class="flex-mid fb-icon mb-40"
          target="_blank"
        >
          <div>Facebook Messenger</div>
        </a>
        <div class="fs-20 fw-700 mb-16">Connect with us on LINE</div>
        <img
          src="../assets/images/registor/line-qr-code.png"
          class="image-line"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "setup-wizard",
  data() {
    return {
      steps: 1,
      selectLocation: "TH",
      gen_question: "8:00 AM",
      rewardSelected: "companyPerks",
      helpModalStatus: false,
      sendModalStatus: false,
      savePeerFeedbackInput: false,
      savePeerFeedbackValue: "",
      createTeamForm: {
        teamName: null,
        managerName: null,
        emailManager: null,
        members: [
          { name: null, email: null },
          { name: null, email: null },
          { name: null, email: null },
        ],
      },
      coreValueData: [
        {
          label: "Customer-centric",
          id: "Customer-centric",
        },
        {
          label: "Teamwork",
          id: "Teamwork",
        },
        {
          label: "Integrity",
          id: "Integrity",
        },
        {
          label: "Learning",
          id: "Learning",
        },
        {
          label: "Excellence",
          id: "Excellence",
        },
      ],
      validateTeamForm: {
        teamName: false,
        managerName: false,
        emailManager: false,
        detectEmailManager: false,
        members: [
          { name: false, email: false, detectEmail: false },
          { name: false, email: false, detectEmail: false },
          { name: false, email: false, detectEmail: false },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.refresh == "true") {
      this.$router.push({ name: "setup-wizard", query: { refresh: "false" } });
    }
  },
  methods: {
    showPeerFeedbackInput() {
      this.savePeerFeedbackInput = true;
      this.$nextTick((_) => {
        this.$refs.savePeerFeedbackInput.focus();
      });
    },
    handleInputPeerFeedbackConfirm() {
      if (this.savePeerFeedbackValue) {
        this.coreValueData.push({
          label: this.savePeerFeedbackValue,
          id: this.savePeerFeedbackValue,
        });
        this.savePeerFeedbackValue = "";
      }
      this.savePeerFeedbackInput = false;
    },
    removeTag(index) {
      this.coreValueData.splice(index, 1);
    },
    validateData() {
      const value = ["teamName", "managerName", "emailManager"];
      for (let i = 0; i < value.length; i++) {
        this.validateTeamForm[value[i]] = true;
        let status = this.$utils(
          "watchingTrim",
          this.createTeamForm[value[i]] || ""
        );
        if (status) {
          this.validateTeamForm[value[i]] = false;
        } else {
          this.validateTeamForm[value[i]] = true;
        }
      }
      let detectEmailMember = true;
      for (let i = 0; i < this.validateTeamForm.members.length; i++) {
        let name = this.$utils(
          "watchingTrim",
          this.createTeamForm.members[i].name || ""
        );
        let email = this.$utils(
          "watchingTrim",
          this.createTeamForm.members[i].email || ""
        );
        let detectEmail = this.$utils(
          "validateEmail",
          this.createTeamForm.members[i].email || ""
        );
        let checkedMail = false;
        if (email) {
          checkedMail = detectEmail;
        }
        if ((name && email) || (!name && !email)) {
          this.validateTeamForm.members[i].email = false;
          this.validateTeamForm.members[i].name = false;
          if (!this.createTeamForm.members[i].email == "") {
            this.validateTeamForm.members[i].detectEmail = !checkedMail;
            if (detectEmailMember) {
              detectEmailMember = checkedMail;
            }
          } else {
            this.validateTeamForm.members[i].detectEmail = false;
          }
        } else if (name) {
          this.validateTeamForm.members[i].email = !email;
          this.validateTeamForm.members[i].detectEmail = !checkedMail;
          detectEmailMember = true;
          detectEmailMember = false;
        } else if (email) {
          this.validateTeamForm.members[i].detectEmail = !detectEmail;
          this.validateTeamForm.members[i].name = !name;
          detectEmailMember = false;
        }
      }

      if (!this.validateTeamForm.email) {
        this.validateTeamForm.detectEmailManager = !this.$utils(
          "validateEmail",
          this.createTeamForm.emailManager
        );
      } else {
        this.validateTeamForm.detectEmailManager = true;
      }

      let createTeamForm =
        !this.validateTeamForm.teamName &&
        !this.validateTeamForm.managerName &&
        !this.validateTeamForm.emailManager &&
        !this.validateTeamForm.detectEmailManager &&
        detectEmailMember;

      if (createTeamForm) {
        this.steps = 3;
      }
    },
    inviteMember() {
      const data = {
        selectLocation: this.selectLocation,
        gen_question: this.gen_question,
        rewardSelected: this.rewardSelected,
        teamName: this.createTeamForm.teamName,
        managerName: this.createTeamForm.managerName,
        emailManager: this.createTeamForm.emailManager,
        members: this.createTeamForm.members,
      };
      
      this.$store.dispatch("newteam/createTeam", {team_name:this.createTeamForm.teamName});
      this.$store.dispatch("register/inviteMember", 
      {members:this.createTeamForm.members,
      manager:{managerName: this.createTeamForm.managerName,emailManager: this.createTeamForm.emailManager,}});
      
      this.$store.dispatch("register/registerMember", 
      {members:this.createTeamForm.members,
      manager:{managerName: this.createTeamForm.managerName,emailManager: this.createTeamForm.emailManager,},recognitionValue:this.coreValueData,gen_question: this.gen_question,});
      // TODO: Invited members function!
      this.sendModalStatus = true;
    },
    addSlotMember() {
      if (this.validateTeamForm.members.length < 20) {
        this.validateTeamForm.members.push({
          name: false,
          email: false,
          detectEmail: false,
        });
        this.createTeamForm.members.push({ name: null, email: null });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-sended {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}
.send-email-card {
  box-shadow: 0 0 44px #0000003b;
  background-color: #fff;
  height: 480px;
  width: 520px;
}
.fb-icon {
  padding: 7px 12px;
  text-decoration: none;
  position: relative;
  background-color: #009dfa;
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 6px #00000052;
  width: 192px;
  font-size: 18px;
  font-weight: 700;
  > .icon-messager {
    position: absolute;
    left: 18px;
  }
}
.input-titile {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}
.node-cycle {
  width: 36px;
  height: 32px;
  padding-top: 4px;
  color: #fff;
  font-size: 14px;
  border-radius: 36px;
  font-weight: 700;
  margin: 0 auto 10px;
  transition: background-color 0.3s;
  background-color: #e8e8e8;
}
.node-process {
  background-color: #6c40cc;
}
.node-done {
  background-color: #6c40cc20;
}
.relative.node {
  width: 60px;
}
.step-title {
  width: 200px;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.line-nonde {
  background-color: #e8e8e8;
  height: 1px;
  width: 140px;
  margin-bottom: 10px;
  transition: background-color 0.3s;
}
.line-done {
  background-color: #6c40cc20;
}
.border-container {
  background-color: #fff;
  width: 960px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}
.border-container.p-40 {
  width: calc(960px - 80px);
}
.big-buttom {
  position: relative;
  background-color: #32c2d5;
  color: #fff;
  border-radius: 3px;
  height: 52px;
  cursor: pointer;

  .icon-buttom-primary {
    position: absolute;
    right: 24px;
  }
}
.step-one-image {
  position: absolute;
  transform: translate(500px, -200px);
}
.step-two-image {
  position: absolute;
  right: 60px;
  top: 55px;
}
.gird-2-reward {
  display: grid;
  grid-template-columns: 50% auto;
}
.gap-24 {
  gap: 24px;
}
.gap-16 {
  gap: 16px;
}
.text-add-more {
  position: absolute;
  bottom: 10px;
}
.add-more {
  font-size: 15px;
  color: #6c40cc;
  border: 1px solid #6c40cc;
  border-width: 0 0 1px 0;
  cursor: pointer;
}
.card-reward {
  transition: border-color 0.4s;
  border: 1px solid #707070;
  height: 100px;
  padding: 34px;
  cursor: pointer;
}
.card-reward.disable-card {
  cursor: default;
  transition: border-color 0.4s;
  border: 1px solid rgba($color: #000000, $alpha: 0.05);
  background-color: rgba($color: #000000, $alpha: 0.05);
  .checkbox-reward {
    opacity: 0.3;
    border: 2px solid #000;
    background-color: rgba($color: #000000, $alpha: 0.05);
  }
}
.checkbox-reward {
  min-width: 26px;
  width: 26px;
  height: 26px;
  border-radius: 26px;
  margin-right: 24px;
  transition: border-color 0.4s, background-color 0.4s;
  background-color: #fff;
  border: 2px solid #707070;
  > .checkbox {
    transition: background-color 0.4s;
    background-color: #fff;
  }
  > .reward-checked {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 28px;
    background-color: #6c40cc;
    &::after {
      content: "";
      position: absolute;
      border: 2px solid #fff;
      border-width: 0 0 3px 3px;
      width: 14px;
      height: 5px;
      left: 5px;
      top: 8px;
      transform: rotate(-45deg);
    }
  }
}
.checkbox-reward.checked {
  border: 2px solid #6c40cc;
  background-color: #6c40cc;
}
.card-checked {
  border: 1px solid #6c40cc;
}
.margin-content-reward {
  margin-right: 35px;
}
.inputLabelStyle {
  padding-top: 6px;
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
}
.inputReportStyle {
  font-size: 18px;
  width: 250px !important;
  margin-left: 12px;
}
.inputReportStyle.red >>> input.el-input__inner {
  border-color: #f44336;
}
.modal-body {
  padding: 2px 63px 2px 28px;
  word-break: break-word;
}
.core-value-container {
  display: inline-block;
  position: relative;
  width: 600px;
  .btn-input {
    background-color: #6c30cc;
    height: 43px;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
  }
}
.core-value-tag {
  color: #6c30cc;
  border-width: 1px;
  border-color: #6c30cc;
  background-color: #fff;
  margin-right: 8px;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 16px;
  color: #6c30cc;
}
.core-value-tag.el-tag {
  padding: 0px 12px;
}
.core-value-add-btn {
  background-color: #6c30cc;
  height: 43px;
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  padding: 0 1.2rem;
}
.core-value-add-btn.input {
  background-color: #fff;
  color: #6c30cc;
  border: 1px solid #6c30cc;
  outline: none;
}
</style>

<style lang="scss">
.gray-input {
  width: 240px;
  div > .el-input__inner {
    background-color: #f4f4f4;
    border-width: 0px;
  }
}
#stepFourCard .el-input .el-input__inner {
  color: #3b3b3b;
  font-weight: 400;
  height: 52px;
}
#stepFourCard .el-input--prefix .el-input__icon {
  padding: 1px 0 0 6px;
}
#stepFourCard .el-input--prefix .el-input__inner {
  padding-left: 140px;
}
</style>
